module.exports = __webpack_public_path__ + "static/media/erp_arrow.827d52f4.svg";